/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
  GetApiV1ExamClassRoomDisciplinesStatus401,
  GetApiV1ExamClassRoomDisciplinesStatus500,
} from "../../types/examEvaluationController/GetApiV1ExamClassRoomDisciplinesStatus.ts";

function getGetApiV1ExamClassRoomDisciplinesStatusUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/class-room-disciplines-status` as const,
  };
  return res;
}

/**
 * @description Retorna todos os status de disciplinas de turma disponíveis, ordenados por descrição, para uso em componentes de seleção ao filtrar aulas de uma prova. **(Requer Authorization para autenticação)**
 * @summary Listar status de disciplinas de turma para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/class-room-disciplines-status}
 */
export async function getApiV1ExamClassRoomDisciplinesStatus(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamClassRoomDisciplinesStatus401
      | GetApiV1ExamClassRoomDisciplinesStatus500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamClassRoomDisciplinesStatusUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
